import { T } from "@/components/T";
import { useLanguage } from "@/contexts/LanguageContext";

export function TestimonialsSection() {
  const { lang } = useLanguage();
  const quotes = lang === "it"
    ? [
        { text: "La sopraelevazione è stata montata in una settimana. Non avrei mai pensato che potesse andare così veloce e in modo così pulito. Il team di Holzbuddy ha mantenuto ciò che aveva promesso.", name: "Famiglia W.", ort: "Merano · Sopraelevazione" },
        { text: "Il nostro hotel è stato ampliato con un complesso di lodge durante la bassa stagione. Nemmeno un giorno di ritardo.", name: "Albergatore M.", ort: "Val Venosta · Edilizia alberghiera" },
        { text: "Finalmente una falegnameria che pianifica davvero. Non improvvisa. La struttura del tetto è stata consegnata con precisione.", name: "Architetto G.", ort: "Bolzano · Struttura del tetto" },
      ]
    : [
        { text: "Die Aufstockung war in einer Woche montiert. Ich hätte nie gedacht, dass das so schnell und sauber geht. Das Team von Holzbuddy hat geliefert, was versprochen wurde.", name: "Familie W.", ort: "Meran · Aufstockung" },
        { text: "Unser Hotel wurde in der Zwischensaison um eine Lodge-Anlage erweitert. Kein einziger Tag Verzögerung.", name: "Hotelier M.", ort: "Vinschgau · Hotelbau" },
        { text: "Endlich eine Zimmerei, die wirklich plant. Nicht erst improvisiert. Der Dachstuhl wurde präzise geliefert.", name: "Architekt G.", ort: "Bozen · Dachstuhl" },
      ];

  return (
    <section data-testid="testimonials-section" className="section-gap bg-hb-off-white relative overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <span className="font-cormorant font-light text-hb-dark/[0.032] leading-none whitespace-nowrap" style={{ fontSize: "clamp(80px, 16vw, 200px)" }}>
          <T de="Qualität" it="Qualità" />
        </span>
      </div>
      <div className="container-hb relative z-10">
        <span className="label-text block mb-10 text-center reveal">
          <T de="Kundenstimmen" it="Testimonianze" />
        </span>
        <div data-testid="testimonial-0" className="max-w-3xl mx-auto text-center mb-16 reveal">
          <span className="font-cormorant font-light leading-none block mb-4 text-hb-yellow/40" style={{ fontSize: "80px" }}>&ldquo;</span>
          <p className="font-cormorant font-light text-hb-dark leading-[1.25] mb-8" style={{ fontSize: "clamp(22px, 3.2vw, 38px)" }}>
            {quotes[0].text}
          </p>
          <div className="flex items-center justify-center gap-4">
            <span className="w-8 h-px bg-hb-yellow" />
            <div className="text-left">
              <p className="font-manrope font-bold text-hb-dark text-sm">{quotes[0].name}</p>
              <p className="text-xs font-inter" style={{ color: "#8a8578" }}>{quotes[0].ort}</p>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-hb-border max-w-3xl mx-auto">
          {quotes.slice(1).map((t, i) => (
            <div key={i} data-testid={`testimonial-${i + 1}`} className="bg-hb-off-white p-8 reveal">
              <p className="text-sm text-hb-text font-inter leading-relaxed italic mb-5">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3">
                <span className="w-4 h-px bg-hb-yellow" />
                <div>
                  <p className="font-manrope font-bold text-hb-dark text-xs">{t.name}</p>
                  <p className="text-[10px] font-inter" style={{ color: "#8a8578" }}>{t.ort}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
